import React, { useEffect } from "react";
import { Text } from "react-native-paper";
import { actionCreators } from "./action";
import { connect } from "react-redux";
import routes from "./../../routing/routes";

const SignOut = ({ signOut, user, navigation }) => {
  useEffect(() => {
    signOut();
  }, []);

  if (user === null) {
    navigation.navigate(routes.Start);
  }
  return <Text> </Text>;
};

const mapStateToProps = (state) => {
  const user = state.user;

  return { user };
};

export default connect(mapStateToProps, actionCreators)(SignOut);
